import __request__ from "routing/request";
export function all(page, requestOptions) {
  return __request__("GET", "/system/messages", null, { "page": page }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
